let html = `<div class="explorer layer--width">
    <div class="explorer__left">
        <div class="explorer__card">
            <div class="explorer-card">
                <div class="explorer-card__head">
                    <div class="explorer-card__head-left">
                        <div class="explorer-card__head-img selector">
                            <img alt="">
                        </div>
                    </div>
                    <div class="explorer-card__head-body">
                        <div class="explorer-card__head-create"></div>
                        <div class="explorer-card__head-rate">
                            <svg><use xlink:href="#sprite-star"></use></svg>
                            <span></span>
                        </div>
                    </div>
                </div>

                <div class="explorer-card__body">
                    <div class="explorer-card__title"></div>
                    <div class="explorer-card__genres"></div>
                    <div class="explorer-card__descr"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="explorer__files">
        <div class="explorer__files-head">
            
        </div>
        <div class="explorer__files-body"></div>
    </div>
</div>`

export default html